// import { useCallback, useEffect, useRef } from 'react';
// import { getPathFromState, StackActions, type NavigationState } from '@react-navigation/native';
// import { linking } from '../../../../Navigator/linking';

// type UseSmartNavigateOptions = {
//   navigation: any;
//   intentTtlMs?: number;
//   baseOrigin?: string;
// };

// type SmartNavigateArgs = {
//   goTo: string;
//   data?: any;
//   navigation?: any; // optional override
//   replace?: boolean
// };

// const normalizeOrigin = (origin: string) => origin.replace(/\/+$/, '');

// const buildUrlFromLinking = (
//   goTo: string,
//   data: any,
//   baseOrigin: string
// ) => {
//   const state: NavigationState = {
//     stale: false,
//     type: 'stack',
//     key: `stack-${Date.now()}`,
//     index: 0,
//     routeNames: [goTo],
//     routes: [
//       {
//         name: goTo as never,
//         params: (data ?? undefined) as never,
//         key: `${goTo}-${Date.now()}`,
//       } as any,
//     ],
//   };

//   const path = getPathFromState(state, linking.config);
//   const withLeadingSlash = path
//     ? path.startsWith('/') ? path : `/${path}`
//     : '/';

//   return `${normalizeOrigin(baseOrigin)}${withLeadingSlash}`;
// };

// export const useSmartNavigate = ({
//   navigation,
//   intentTtlMs = 250,
//   baseOrigin,
// }: UseSmartNavigateOptions) => {
//   const intentRef = useRef<{ ts: number; openNewTab: boolean }>({
//     ts: 0,
//     openNewTab: false,
//   });

//   // 🖱️ global mouse intent (web only)
//   useEffect(() => {
//     if (typeof window === 'undefined') return;

//     const onMouseDown = (e: MouseEvent) => {
//       intentRef.current = {
//         ts: Date.now(),
//         openNewTab: e.button === 1 ||
//          e.ctrlKey || e.metaKey,
//       };
//     };

//     window.addEventListener('mousedown', onMouseDown, true);
//     return () => window.removeEventListener('mousedown', onMouseDown, true);
//   }, []);

//   const shouldOpenInNewTab = useCallback(() => {
//     const { ts, openNewTab } = intentRef.current;
//     return openNewTab && Date.now() - ts <= intentTtlMs;
//   }, [intentTtlMs]);

// //   const openInNewTab = useCallback(
// //   (goTo: string, data?: any) => {
// //     if (typeof window === 'undefined') return;

// //     const origin = baseOrigin ?? window.location.origin;
// //     const url = buildUrlFromLinking(goTo, data, origin);

// //     // попробуем открыть и сразу сфокусировать вкладку
// //     const newWin = window.open(url, '_blank', 'noopener,noreferrer');

// //     // if (newWin) {
// //     //   // некоторые браузеры требуют чуть позже
// //     //   // newWin.focus();
// //     //   // setTimeout(() => newWin.focus(), 0);
// //     // }
// //   },
// //   [baseOrigin]
// // );

// const openInNewTab = useCallback(
//   (goTo: string, data?: any) => {
//     if (typeof window === 'undefined') return;

//     const origin = baseOrigin ?? window.location.origin;
//     const url = buildUrlFromLinking(goTo, data, origin);

//     // Делегируем браузеру поведение табов
//     const a = document.createElement('a');
//     a.href = url;
//     a.target = '_blank';
//     a.rel = 'noopener noreferrer';

//     // важно: чтобы сработал клик (некоторые браузеры)
//     a.style.display = 'none';
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//   },
//   [baseOrigin]
// );


//   const smartNavigate = useCallback(
//     ({ goTo, data, navigation: navigationOverride, replace = false}: SmartNavigateArgs) => {
//       const navToUse = navigationOverride ?? navigation;

//       if (!navToUse?.navigate) {
//         console.error(
//           'useSmartNavigate: navigation is missing or invalid',
//           navToUse
//         );
//         return;
//       }

//       if (shouldOpenInNewTab()) {
//         openInNewTab(goTo, data);
//         return;
//       }

//       try {
//         if (data !== undefined) {
//           if(replace){
//             navToUse.dispatch(StackActions.replace(goTo, data));
//             if (typeof window !== 'undefined') {
//             const origin = baseOrigin ?? window.location.origin;
//             const url = buildUrlFromLinking(goTo, undefined, origin); // <- no params
//             window.history.replaceState(null, '', url);
//           }
//             return
//           }

//           navToUse.navigate(goTo, data);
//         }
//         else {
//           if(replace){
//             navToUse.dispatch(StackActions.replace(goTo));
//             if (typeof window !== 'undefined') {
//               const origin = baseOrigin ?? window.location.origin;
//               const url = buildUrlFromLinking(goTo, undefined, origin); // <- no params
//               window.history.replaceState(null, '', url);
//             }
//             return
//           }
//           navToUse.navigate(goTo);
//         }
//       } catch (e) {
//         console.error('Navigate error:', e);
//       }
//     },
//     [navigation, openInNewTab, shouldOpenInNewTab]
//   );

//   return { smartNavigate, openInNewTab };
// };


import { useCallback, useEffect, useRef } from 'react';
import {
  getPathFromState,
  StackActions,
  type NavigationState,
} from '@react-navigation/native';
import { linking } from '../../../../Navigator/linking';

type UseSmartNavigateOptions = {
  navigation: any;
  intentTtlMs?: number;
  baseOrigin?: string;
};

type SmartNavigateArgs = {
  goTo: string;
  data?: any;
  navigation?: any; // optional override
  replace?: boolean;
};

const normalizeOrigin = (origin: string) => origin.replace(/\/+$/, '');

const buildUrlFromLinking = (goTo: string, data: any, baseOrigin: string) => {
  const state: NavigationState = {
    stale: false,
    type: 'stack',
    key: `stack-${Date.now()}`,
    index: 0,
    routeNames: [goTo],
    routes: [
      {
        name: goTo as never,
        params: (data ?? undefined) as never,
        key: `${goTo}-${Date.now()}`,
      } as any,
    ],
  };

  const path = getPathFromState(state, linking.config);
  const withLeadingSlash = path ? (path.startsWith('/') ? path : `/${path}`) : '/';

  return `${normalizeOrigin(baseOrigin)}${withLeadingSlash}`;
};

export const useSmartNavigate = ({
  navigation,
  intentTtlMs = 250,
  baseOrigin,
}: UseSmartNavigateOptions) => {
  const intentRef = useRef<{ ts: number; openNewTab: boolean }>({
    ts: 0,
    openNewTab: false,
  });

  // 🖱️ global mouse intent (web only)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const onMouseDown = (e: MouseEvent) => {
      intentRef.current = {
        ts: Date.now(),
        openNewTab: e.button === 1 || e.ctrlKey || e.metaKey,
      };
    };

    window.addEventListener('mousedown', onMouseDown, true);
    return () => window.removeEventListener('mousedown', onMouseDown, true);
  }, []);

  const shouldOpenInNewTab = useCallback(() => {
    const { ts, openNewTab } = intentRef.current;
    return openNewTab && Date.now() - ts <= intentTtlMs;
  }, [intentTtlMs]);

  // максимально "нативно": якорь-клик
  const openInNewTab = useCallback(
    (goTo: string, data?: any) => {
      if (typeof window === 'undefined') return;

      const origin = baseOrigin ?? window.location.origin;
      const url = buildUrlFromLinking(goTo, data, origin);

      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.style.display = 'none';

      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    [baseOrigin]
  );

  const smartNavigate = useCallback(
    ({
      goTo,
      data,
      navigation: navigationOverride,
      replace = false,
    }: SmartNavigateArgs) => {
      const navToUse = navigationOverride ?? navigation;

      if (!navToUse?.navigate) {
        console.error('useSmartNavigate: navigation is missing or invalid', navToUse);
        return;
      }

      if (shouldOpenInNewTab()) {
        openInNewTab(goTo, data);
        return;
      }

      try {
        if (replace) {
          // replace with state params (native)
          navToUse.dispatch(StackActions.replace(goTo, data));

          // web: если хочешь /catalog без query — чистим URL
          if (typeof window !== 'undefined') {
            const origin = baseOrigin ?? window.location.origin;
            const url = buildUrlFromLinking(goTo, undefined, origin); // no params in url
            window.history.replaceState(null, '', url);
          }
          return;
        }

        // normal navigate
        if (data !== undefined) navToUse.navigate(goTo, data);
        else navToUse.navigate(goTo);
      } catch (e) {
        console.error('Navigate error:', e);
      }
    },
    [navigation, openInNewTab, shouldOpenInNewTab, baseOrigin]
  );

  return { smartNavigate, openInNewTab };
};
